import { render, staticRenderFns } from "./DetalleClientes.vue?vue&type=template&id=7f7a55d1&"
import script from "./DetalleClientes.vue?vue&type=script&lang=ts&"
export * from "./DetalleClientes.vue?vue&type=script&lang=ts&"
import style0 from "./DetalleClientes.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports